import { createComponent } from '@lit/react';
import React from 'react';
import { createRoot } from 'react-dom/client';

import packageJson from "../package.json";
import { GoogleMap as GoogleMapWC } from './features/odu/components/MapPicker/google-map';
import loadFacebookPixel from "./Shared/helper/facebookPixel";
import { isNewHeaderFooter, isNewHomeContent } from './Shared/helper/helper';

// import Footer from './Shared/Components/Footer/Footer';
// import Header  from './Shared/Components/Header/Header';

import App from './app';
import analytics from './FTTX/analytics';
const domNode = document.getElementById('root');
const root = createRoot(domNode);

analytics.initialize();
loadFacebookPixel();

if (isNewHeaderFooter() || isNewHomeContent()) {
  import("./index.scss");
}
else {
  import("./index-old.scss");
}


const GoogleMap = createComponent({
  react: React,
  tagName: 'google-map',
  elementClass: GoogleMapWC,
  // Defines props that will be event handlers for the named events
  events: {
    onLocationChange: 'location-change'
  },
});

console.log(`%cAirtel - Portal Team(v${packageJson.version}) ⓒ ${(new Date).getFullYear()}`, "color: #e40000; font-size: 18px; font-weight: bold")
root.render(<App />);

// const gaScript = document.createElement('script');
// // gaScript.src = "assets/js/gtag.js";
// // gaScript.preload = true;
// document.head.appendChild(gaScript);

const script = document.createElement('script');
script.src = `https://www.googletagmanager.com/gtag/js?id=${process.env.REACT_APP_GOOGLE_ANALYTIC_ID}`;
script.async = true;
document.head.appendChild(script);
if (process.env.REACT_APP_OPCO == "NG") {
  const paystackScript = document.createElement('script');
  paystackScript.src = `https://js.paystack.co/v1/inline.js`;
  paystackScript.async = true;
  document.head.appendChild(paystackScript);
}

window['dataLayer'] = window['dataLayer'] || [];
window['gtag'] = function () {
  window['dataLayer'].push(arguments);
};
window['gtag']('js', new Date());
window['gtag']('config', process.env.REACT_APP_GOOGLE_ANALYTIC_ID);
window['reactParams'] = { opco: process.env.REACT_APP_OPCO };

// Load Google Tag Manager
const gtmScript = document.createElement("script");
gtmScript.async = true;
gtmScript.src = `https://www.googletagmanager.com/gtm.js?id=${process.env.REACT_APP_GTM_ID}`;
document.head.appendChild(gtmScript);



async function initSentry() {
  const Sentry = await import("@sentry/react");

  Sentry.init({
    dsn: process.env.REACT_APP_SENTRY_CDN_URL,
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration()
    ],
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ["localhost"],
  });
}
// call only when you want to start tracking

if (process.env.REACT_APP_SENTRY_ENABLE === "true") {
  initSentry();
}
